import useProject from '@hooks/useProject';

import GoogleMap from './GoogleMap';
import InaviMap from './InaviMap';
import { MapProps } from './types';

function Map(props: MapProps) {
    const project = useProject();
    if (project?.serviceCountry !== 'KR') {
        return <GoogleMap {...props}/>;
    }
    return (
        <InaviMap {...props} />
    );
}

export default Map;
